import { AppMonitoringHealthMetric, IntegrationType } from '../../types';

export const MAX_DATA_AGE_MINUTES_LIMIT = 60 * 24 * 7;

export const DEFAULT_MAX_DATA_AGE_MINUTES = 10;

export const isCustomObaaMetric = (metric?: AppMonitoringHealthMetric): boolean =>
    metric?.integrationId === IntegrationType.CustomAnalytics;

export const validatePositiveMaxDataAgeMinutes = (_: unknown, value: unknown): Promise<void> => {
    if (value === undefined || value === null || value === '') {
        return Promise.resolve();
    }
    if (typeof value !== 'number' || !Number.isInteger(value) || value < 1) {
        return Promise.reject(new Error('Enter a whole number of minutes greater than 0'));
    }
    if (value > MAX_DATA_AGE_MINUTES_LIMIT) {
        return Promise.reject(new Error(`Enter at most ${MAX_DATA_AGE_MINUTES_LIMIT} minutes (7 days)`));
    }
    return Promise.resolve();
};

export const metricMaxDataAgeMinutesFromFormValue = (
    monitoringConditions?: { id?: string; maxDataAgeMinutes?: number }[],
    monitoringMetrics?: AppMonitoringHealthMetric[],
): Record<string, number> | undefined => {
    const maxDataAgeMinutes: Record<string, number> = {};
    for (const condition of monitoringConditions ?? []) {
        const minutes = condition?.maxDataAgeMinutes;
        if (!condition?.id || minutes == null || !Number.isInteger(minutes) || minutes < 1) {
            continue;
        }
        if (!isCustomObaaMetric(monitoringMetrics?.find((metric) => metric.id === condition.id))) {
            continue;
        }
        maxDataAgeMinutes[condition.id] = minutes;
    }

    return Object.keys(maxDataAgeMinutes).length > 0 ? maxDataAgeMinutes : undefined;
};
